import styled from 'styled-components'

const Badge = styled.span.attrs((props) => ({
  id: props.id || 'badge',
}))`
  display: inline-block;
  text-align: center;
  border: 1px solid;
  border-radius: 10000px;
  height: 1.5em;
  line-height: 1.5em;
  padding: 0 10px;
`

export default Badge

export const TabBadge = styled.span`
  border: none;
  display: inline-block;
  text-align: center;
  border-radius: 10000px;
  line-height: 1.5em;
  /* --primary-color is text; use primary button pairing for readable contrast in both themes */
  background-color: var(--button-primary-bg-default);
  color: var(--button-primary-text-default);
  margin-left: 10px;
  height: 17px;
  font-size: 10px;
  padding: 1px 8px;
  font-weight: normal !important;
`

const miniBadgeSize = 15
export const MiniBadge = styled(Badge)`
  position: absolute;
  top: -${miniBadgeSize / 3}px;
  right: -2px;
  font-size: 10px;
  color: white;
  background-color: ${({ customBackgroundColor }) => customBackgroundColor || '#565b6d'};
  border: 1px solid var(--white) !important;
  min-width: ${miniBadgeSize}px;
  height: ${miniBadgeSize}px;
  line-height: 13px;
  padding: 0 3px;
  transform: translateX(50%);
  border: none;
`

const priorityFill = (priority) => {
  const level = Number(priority)
  if (level === 3) {
    return 'var(--priority-low)'
  }
  if (level === 1) {
    return 'var(--priority-high)'
  }
  return 'var(--priority-medium)'
}

const priorityLabelColor = (priority) => {
  const level = Number(priority)
  if (level === 3) {
    return 'var(--priority-pill-text-on-low)'
  }
  if (level === 1) {
    return 'var(--priority-pill-text-on-high)'
  }
  return 'var(--priority-pill-text-on-medium)'
}

export const PriorityBadge = styled.span.attrs(({ id, priority }) => ({
  id: id || 'priority-badge',
  ...(priority !== undefined && priority !== null && `${priority}` !== ''
    ? { 'data-priority': String(priority) }
    : {}),
}))`
  color: ${({ priority }) => priorityLabelColor(priority)};
  font-size: 10px;
  text-align: center;
  font-weight: bold;
  width: 55px;
  height: 18px;
  padding: 2px 0;
  display: ${(props) => (!props.priority ? 'none' : 'inline-block')};
  border-radius: 100px;
  background-color: ${({ priority }) => priorityFill(priority)};
  text-transform: uppercase;
`

export const MenuBadge = styled(Badge)`
  min-width: 25px;
  margin-left: 8px;
  height: 24px;
  line-height: 16px;
  padding: 3px 8px;
  font-size: 12px;
  font-weight: bold;

  border-color: #bdc3dd;

  color: ${(props) => (props.selected ? 'var(--legacy-sidebar-selected-badge-color)' : '#BDC3DD')};
  background-color: ${(props) => (props.selected ? '#BDC3DD' : 'transparent')};
`

export const MenuProgressBadge = styled(Badge)`
  display: inline-block;
  margin-left: 52px;
  min-width: 25px;
  height: 22px;
  line-height: 23px;
  padding: 0 7px;
  font-size: 12px;
  font-weight: bold;
  border: none;
  color: #fff;
  display: ${(props) => props.progress === undefined && 'none'};
  background: ${(props) => (props.progress ? '#0152CC' : '#33B200')};
`

const miniIconSize = 15
export const MiniIcon = styled(Badge)`
  color: white;
  font-size: 10px;
  line-height: ${miniIconSize}px;
  min-width: ${miniIconSize}px;
  height: ${miniIconSize}px;
  padding: ${(props) => props.padding || '0 3px'};
  position: absolute;
  top: ${(props) => props.top || `-${miniIconSize / 4}px`};
  left: ${(props) => props.left || '3px'};
  right: ${(props) => props.right};
  z-index: 1;
  border: none;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.8);
  background-color: ${(props) => props.backgroundColor || '#E44258'};
`
